import { Separator, Skeleton } from "@/components/ui";

export const SexualHistorySkeleton = () => {
  return (
    <div
      className="flex flex-col gap-2 rounded transition-colors mt-1 px-3 py-2"
      data-testid="sexual-history-skeleton"
    >
      <div className="flex flex-row gap-2">
        <Skeleton className="h-10 w-1/2" />
        <Skeleton className="h-10 w-1/2" />
      </div>
      <Separator />
    </div>
  );
};
